import angular from "angular";
import Vue from "vue";
import "ngVue";

import AppNextLink from "./AppNextLink.vue";

export default angular
  .module("directives.appnextlink", [])
  .directive("dcAppNextLink", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcAppNextLink", AppNextLink));
    },
  ]);
